<template>
  <div class="mobile-container" @touchmove.prevent>
    <img class="custom-vip" src="../resource/vip.png"/>
  </div>
</template>

<script>
import {onMounted} from 'vue';
import 'element-plus/es/components/carousel/style/css';
import 'element-plus/es/components/carousel-item/style/css';
import { useRouter } from 'vue-router'

export default {
  name: 'JoinVip',
  setup() {

    // 组件挂载后的执行逻辑
    onMounted(() => {
      // user.value = JSON.parse(sessionStorage.getItem("loginUser"));
    });
    const router = useRouter()
    //  定义跳转函数
    const goToAbout = () => {
      router.push({
        path: '/About',
        // 可选：传递查询参数
        query: {
          from: 'home-page'
        }
      })
    }

    //  定义跳转函数
    const goToOrder = () => {
      router.push({
        path: '/Order',
      })
    }
    //  定义跳转函数
    const goToCredits = () => {
      router.push({
        path: '/Credits',
      })
    }

    return {
      goToAbout,
      goToOrder,
      goToCredits
    };
  },
};
</script>

<style scoped>
/* 可选：清除默认边距，避免滚动异常 */
body, html {
  margin: 0;
  padding: 0;
  overflow: hidden;
  touch-action: none; /* 禁止页面整体触摸滑动 */
}

/* 基础样式 */
.mobile-container {
  height: 50vh;
  width: 50vw;
  max-width:  50vw;
  max-height: 50vh;
  position: fixed;
  overflow: hidden !important; /* 强制隐藏溢出 */
  touch-action: none; /* 禁止触摸交互 */
  background: linear-gradient(to bottom right, #33872B, #d8ffd0);
  /*background-color: #EAF0E6;*/ /* 黄白色*/
}

/*父级框*/
.custom-vip {
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）2vh */
  /* 给个基础尺寸，可根据需求调整 */
  width:  50%;
  overflow: hidden;
  height:  50%;
}

/* 适配小屏幕 */
@media screen and (max-width: 480px) {
  .el-tabs__item {
    padding: 0 8px;
  }

  .mobile-aside {
    width: 80%;
  }

  .mobile-main {
    transform: translateX(80%) translateX(-20px);
  }
}
</style>